import { useTranslation } from 'react-i18next';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useGetEmployeeIdentification } from '@/common/integrations/menhir/employee/employee/employee.hooks';

export function DocumentsSection() {
  const { t } = useTranslation();
  const {
    employeeIdentification: citizenCard,
    isInitialLoading: isCitizenCardLoading,
  } = useGetEmployeeIdentification('citizen-card');
  const {
    employeeIdentification: transportationCard,
    isInitialLoading: isTransportationCardLoading,
  } = useGetEmployeeIdentification('transportation-card');

  if (isCitizenCardLoading || isTransportationCardLoading) {
    return null;
  }

  return (
    <CardActionGroup title={t('dashboard.documents.title')} size="sm">
      <CardActionLink
        title={t('dashboard.documents.links.id_card.title')}
        icon={<Icon icon="id-badge" />}
        href={{
          pathname: citizenCard
            ? ROUTES.DOCUMENT_DETAILS
            : ROUTES.DOCUMENT_FORM,
          params: { documentType: 'citizen-card' },
        }}
      />
      <CardActionLink
        title={t('dashboard.documents.links.transportation_card.title')}
        icon={<Icon icon="bus" />}
        href={{
          pathname: transportationCard
            ? ROUTES.DOCUMENT_DETAILS
            : ROUTES.DOCUMENT_FORM,
          params: { documentType: 'transportation-card' },
        }}
      />
    </CardActionGroup>
  );
}
